import {
  Component,
  Input,
} from '@angular/core';
import { IconsDefinitionHelper } from '@shared/common/definition-helper';
import { IRouteStructure } from '@shared/common/routing/IRouteStructure';
import {ClinicianDashboardRoutes} from '@shared/common/routing/clinician-dashboard-routes';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { IconComponent } from '../../../components/icon/icon.component';
import { RouterLink } from '@angular/router';

import {NumberBadgeComponent} from "@app/areas/shared/components/number-badge/number-badge.component";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: true,
  imports: [RouterLink, IconComponent, LocalizeTextPipe, NumberBadgeComponent]
})
export class SidebarComponent extends IconsDefinitionHelper {
  settings = ClinicianDashboardRoutes.ACCOUNT_SETTINGS.view;
  @Input() sidebarItems: IRouteStructure[] = [];
}
